import { render } from "./TreeForm.vue?vue&type=template&id=096db5ce"
import script from "./TreeForm.vue?vue&type=script&lang=js"
export * from "./TreeForm.vue?vue&type=script&lang=js"
script.render = render

export default script